module.exports = __webpack_public_path__ + "static/img/butler.11a9637.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/butler.png
// module id = lozZ
// module chunks = 0